export default __webpack_public_path__ + "static/media/P350_B_BD.883a4084.pdf";